export type Service = {
  title: string;
  description: string;
  /** Short one-liner for the Home services list (mockup `.svc .desc`). */
  blurb: string;
  /** Stable slug for analytics (`service_click`) — avoid sending free-text titles. */
  slug: 'regular' | 'deep' | 'office' | 'move_in_out';
};

export const ServicesCatalog: Service[] = [
  {
    slug: 'regular',
    title: 'Regular house cleaning',
    description:
      'Keep your home fresh, tidy, and comfortable with our regular cleaning service. We take ' +
      'care of the everyday tasks — dusting, vacuuming, mopping, and sanitizing kitchens and ' +
      'bathrooms — so you can enjoy a spotless home without the stress. Whether weekly, ' +
      'bi-weekly or monthly, we will tailor the service to fit your lifestyle and schedule.',
    blurb: 'Everyday care — dusting, floors, kitchens and baths — on a rhythm that fits your week.',
  },
  {
    slug: 'deep',
    title: 'Deep cleaning',
    description:
      'Our deep cleaning service goes beyond the basics to make your home shine from top to ' +
      'bottom. We tackle those hard-to-reach spots, built-up dust, and hidden grime — leaving ' +
      'every corner fresh, sanitized, and sparkling clean. Perfect for a seasonal refresh or ' +
      'whenever your home needs extra care.',
    blurb: 'Top-to-bottom detail for the built-up and hard-to-reach, leaving every corner reset.',
  },
  {
    slug: 'office',
    title: 'Office & Commercial cleaning',
    description:
      'A clean workspace means a productive workspace. Our office and commercial cleaning ' +
      'service keeps your business looking professional and welcoming — dust-free desks, ' +
      'spotless floors, sanitized restrooms, and sparkling common areas. We work around your ' +
      'schedule to ensure your team and clients always enjoy a fresh, healthy environment.',
    blurb: "A professional, welcoming workspace — worked quietly around your team's hours.",
  },
  {
    slug: 'move_in_out',
    title: 'Move-in/Move-out cleaning',
    description:
      'Moving can be stressful — let us handle the cleaning. Our move-in/move-out service ' +
      'makes sure every corner is spotless, from floors and windows to kitchens and bathrooms. ' +
      'Whether you are leaving a place or starting fresh in a new one, we will leave it ' +
      'sparkling clean and ready for the next chapter.',
    blurb: "A spotless handover for the next chapter, wherever you're headed.",
  },
];
